import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {ReactComponent as Logo} from '../../assets/images/ugcan-logo.svg';

export default function VerifyEmailChange() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Verifying...');
  const [loading, setLoading] = useState(true);
  const token = params.get('token');

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setStatus('Invalid verification link. No token provided.');
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/auth/email-change/verify/`, { token }, {
          headers: {
            ...(process.env.REACT_APP_API_KEY && { 'X-API-KEY': process.env.REACT_APP_API_KEY }),
          }
        });
        console.log('Verification response:', response.data);
        setStatus('Email updated successfully! You can now log in with your new email.');
        setLoading(false);
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (e) {
        console.error('Verification error:', e.response?.data || e.message);
        setStatus('Verification failed. The link may have expired or been used already.');
        setLoading(false);
      }
    };

    verifyToken();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-primary-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
        <div className="flex justify-center mb-6">
          <Logo />
        </div>
        
        <h1 className="text-2xl font-bold text-secondary-900 mb-4">
          Email Verification
        </h1>
        
        <div className="mb-6">
          {loading ? (
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-900"></div>
              <span className="ml-2 text-gray-600">{status}</span>
            </div>
          ) : (
            <p className={`text-sm ${status.includes('successfully') ? 'text-green-600' : 'text-red-600'}`}>
              {status}
            </p>
          )}
        </div>

        {!loading && (
          <div className="space-y-3">
            <button
              onClick={() => navigate('/')}
              className="w-full bg-primary-900 text-white py-2 px-4 rounded-lg hover:bg-primary-800 transition-colors"
            >
              Go to Home
            </button>
            
            <button
              onClick={() => navigate('/login')}
              className="w-full bg-transparent text-primary-900 border-2 border-primary-900 py-2 px-4 rounded-lg hover:bg-primary-900 hover:text-white transition-colors"
            >
              Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
